/** Where a user removes the permissions they granted themselves. */
export const MY_APPS_URL = "https://myapps.microsoft.com";
/**
 * Admin consent link for the organization. Without a redirect_uri, Entra sends the admin back to
 * the app's first registered reply URL once the permissions are granted.
 */
export const getAdminConsentUrl = (tenantId, clientId) => `https://login.microsoftonline.com/${tenantId || "organizations"}/adminconsent?client_id=${encodeURIComponent(clientId)}`;
